import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateUserRequest,
  CreateUserResponse,
  UpdateUserRequest,
  GetUserResponseData,
  UserUpdatePasswordRequest,
  UserResponseDataArr,
  UserResponseDataId,
} from './user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private apiUrl = `${environment.apiUrl}/user`;

  constructor(private http: HttpClient) { }

  getOrganizationUsers(
    organizationId: string
  ): Observable<UserResponseDataArr> {
    return this.http.get<UserResponseDataArr>(
      `${this.apiUrl}?filters[organization_id]=${organizationId}`
    );
  }

  createUser(data: CreateUserRequest): Observable<CreateUserResponse> {
    return this.http.post<CreateUserResponse>(`${this.apiUrl}`, data);
  }

  getUser(id: string): Observable<GetUserResponseData> {
    return this.http.get<GetUserResponseData>(`${this.apiUrl}/${id}`);
  }

  updateUser(
    data: UpdateUserRequest,
    id: string
  ): Observable<UserResponseDataId> {
    return this.http.patch<UserResponseDataId>(
      `${this.apiUrl}/${id}`,
      data
    );
  }

  updatePassword(userId: string, data: Partial<UserUpdatePasswordRequest>): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${userId}/password`, data);
  }

  searchUser(search: string, organizationId: string
  ): Observable<UserResponseDataArr> {
    return this.http.get<UserResponseDataArr>(
      `${this.apiUrl}?filters[organization_id]=${organizationId}&search=${search}`
    );
  }
}
